import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    styled,
    Typography,
} from '@mui/material';
import React from 'react';

const FeedbackType = styled(Typography)(() => ({
    padding: '5px 5px 5px 0px',
}));

const TitleType = styled(Typography)(() => ({
    fontSize: '2rem',
}));

const SubtitleType = styled(Typography)(() => ({
    fontSize: '1.2rem',
    padding: '5px 5px 5px 0px',
}));

export const TeacherFeedback = props => {
    // const classes = useStyles();

    // const getDownloadFile = async location => {
    //     return axios
    //         .get(location, {
    //             responseType: 'blob',
    //         })
    //         .then(response => response.data);
    // };

    // const downloadDocument = async () => {
    //     const token = await getAccessTokenSilently();

    //     const url = await axios.get('/getPreBookingDocument', {
    //         baseURL: process.env.REACT_APP_API_GATEWAY,
    //         url: `/getPreBookingDocument`,
    //         timeout: 30000,
    //         headers: {
    //             authorization: `Bearer ${token}`,
    //             'Content-Type': 'application/json',
    //         },
    //         params: {
    //             Date: props.sk1,
    //             Filename: props.schoolUploadDocument,
    //         },
    //     });

    //     getDownloadFile(url.data.Message.Data.downloadURL).then(data =>
    //         saveAs(data, props.schoolUploadDocument)
    //     );
    // };

    return (
        <Card sx={{ margin: '20px 20px 40px', padding: '20px' }}>
            <Grid container>
                <Grid item xs={12}>
                    <TitleType variant="h6">Teacher Feedback</TitleType>
                </Grid>

                {props.report.sessions.map(session => {
                    return (
                        <Grid item xs={12} sm={6} sx={{ padding: '12px' }}>
                            <Card>
                                <CardHeader
                                    data-cy="class-feedback"
                                    title="Class"
                                    subheader={`${session.classname} •
                                        ${session.session}`}
                                    titleTypographyProps={{
                                        color: '#FFF',
                                    }}
                                    subheaderTypographyProps={{
                                        color: '#FFF',
                                    }}
                                    sx={{
                                        backgroundColor: '#878787',
                                        color: '#FFF',
                                    }}
                                />
                                <CardContent>
                                    <Typography data-cy="session-notes">
                                        {session.notes}
                                    </Typography>
                                </CardContent>
                            </Card>{' '}
                        </Grid>
                    );
                })}

                <Grid item xs={12} sm={6}>
                    <SubtitleType variant="h4">
                        Things needing following up:
                    </SubtitleType>
                    <FeedbackType variant="body" data-cy="follow-up">
                        {props.report.followup}
                    </FeedbackType>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <SubtitleType variant="h4">
                        Behaviour Management Required:
                    </SubtitleType>
                    <FeedbackType variant="body" data-cy="behaviour">
                        {props.report.behaviour}
                    </FeedbackType>
                </Grid>

                {/* {props.bookingDocExist &&
                compareDesc(parseISO(props.endDate), Date.now()) === -1 && (
                    <div>
                        <Typography variant="h3">Files</Typography>
                        <Button
                            onClick={() => downloadDocument()}
                            variant="contained"
                            color="default"
                            className={classes.button}
                            startIcon={<CloudUploadIcon />}
                        >
                            <Typography>Download</Typography>
                        </Button>
                    </div>
                )} */}
            </Grid>
        </Card>
    );
};

export default TeacherFeedback;
